// extracted by mini-css-extract-plugin
export default {"wrapper":"QlLanding_wrapper__bBl6f"};